import { Link } from 'react-router-dom';
import moment from 'moment';
import { Box, Typography, Grid } from '@mui/material';

import { FBoxContainer, FSearch } from '../../../../components/base';
import TableHeaderGenerator from '../../../components/TableHeaderGenerator';
import AdminRowLoader from '../../../components/AdminRowLoader';
import { clientAssignmentColumns } from '../../../configs/tableHeaders.config';
import { clinicalRelationshipOptions } from '../../../../constants';
import { useProviderAssignedClientsSection } from '../hooks';
import {
  ASSIGNED_CLIENTS_HEADER_SX,
  ASSIGNED_CLIENTS_ROW_SX,
  ASSIGNED_CLIENTS_SEARCH_SX,
} from '../styles';

import type { ChangeEvent } from 'react';

export function ProviderAssignedClients() {
  const {
    sortedClientAssignments,
    clientAssignmentsLoading,
    clientSearchStr,
    clientAssignmentsSortField,
    clientAssignmentsSortOrder,
    handleClientSearch,
    sortClientAssignments,
  } = useProviderAssignedClientsSection();

  const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
    handleClientSearch(e.target.value);
  };

  let clientAssignmentsContent;
  if (sortedClientAssignments.length > 0) {
    clientAssignmentsContent = sortedClientAssignments.map((pa) => (
      <Grid container key={pa.id} sx={ASSIGNED_CLIENTS_ROW_SX}>
        <Grid item xs={2}>
          {pa.client.id}
        </Grid>
        <Grid item xs={2.5} sx={{ textAlign: 'center' }}>
          <Link to={`/admin/client-details-page/${pa.client.id}`}>
            {pa.client.first_name} {pa.client.last_name}
          </Link>
        </Grid>
        <Grid item xs={2.5} sx={{ textAlign: 'center' }}>
          {
            clinicalRelationshipOptions.find((cr) => cr.value === pa.clinical_relationship)
              ?.label
          }
        </Grid>
        <Grid item xs={2.5} sx={{ textAlign: 'center' }}>
          {moment(pa?.date_start).format('MM/DD/YYYY')}
        </Grid>
        <Grid item xs={2.5} sx={{ textAlign: 'center' }}>
          {pa?.date_end ? moment(pa?.date_end).format('MM/DD/YYYY') : 'N/A'}
        </Grid>
      </Grid>
    ));
  } else if (clientAssignmentsLoading) {
    clientAssignmentsContent = (
      <Box>
        {Array.from({ length: 3 }).map((_, index) => (
          <AdminRowLoader key={index} />
        ))}
      </Box>
    );
  } else {
    clientAssignmentsContent = (
      <Typography variant="h6" textAlign="center" mb={2}>
        No clients assigned to this provider
      </Typography>
    );
  }

  return (
    <FBoxContainer>
      <Grid container direction="column">
        <Box sx={ASSIGNED_CLIENTS_HEADER_SX}>
          <Typography variant="h4" textAlign="left">
            Assigned Clients:
          </Typography>
          <FSearch
            sx={ASSIGNED_CLIENTS_SEARCH_SX}
            value={clientSearchStr}
            autoComplete="off"
            inputHeight={40}
            placeholder="Client name or clinical relationship"
            onChange={handleSearchChange}
          />
        </Box>
        <TableHeaderGenerator
          columns={clientAssignmentColumns}
          handleSorting={sortClientAssignments}
          sortField={clientAssignmentsSortField}
          sortOrder={clientAssignmentsSortOrder}
        />
        {clientAssignmentsContent}
      </Grid>
    </FBoxContainer>
  );
}
